var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledTick1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.55556C0 1.59188 1.59188 0 3.55556 0H17.4444C19.4081 0 21 1.59188 21 3.55556V17.4444C21 19.4081 19.4081 21 17.4444 21H3.55556C1.59188 21 0 19.4081 0 17.4444V3.55556Z",
    fill: "#F2F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63839 9.09703L10.0962 13.5547L8.7589 14.892L4.30112 10.4343L5.63839 9.09703Z",
    fill: "#949494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 13.8867L8.67432 12.5002L15.3726 6.10742L16.6993 7.49398L10.0009 13.8867Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledTick1);
export default __webpack_public_path__ + "static/media/DisabledTick1.b89d1c2e561fb0c3485f07f65d345ad8.svg";
export { ForwardRef as ReactComponent };